export default __webpack_public_path__ + "static/media/search_icon.3934f5e9.svg";